import React from "react";
import { push } from "connected-react-router";
import { reducerType } from "redux/reducers";
import { useDispatch, useSelector } from "react-redux";
import HeaderBarSub from "components/HeaderBarSub";
import Container from "@material-ui/core/Container";
import styles from "./styles";
import FormMyProfile from "components/FormMyProfile";
import GridFullHeight from "components/GridFullHeight";
import GridFormContainer from "components/GridFormContainer";
import { useTranslation } from "react-i18next";

const EditUser = React.memo(() => {
  const current_user = useSelector(
    (state: reducerType) => state.auth.current_user
  );
  const dispatch = useDispatch();
  const classes = styles();
  const openUrl = url => {
    dispatch(push(url));
  };

  const translate = useTranslation().t;

  return (
    <GridFullHeight container>
      <GridFormContainer item xs={12} sm={12} md={12}>
        <GridFullHeight container>
          <HeaderBarSub
            backUrl={"/"}
            openUrl={openUrl}
            name={translate("MANAGE_PROFILE")}
          />
          <Container className={classes.root}>
            <FormMyProfile user={current_user} />
          </Container>
        </GridFullHeight>
      </GridFormContainer>
    </GridFullHeight>
  );
});

export default EditUser;
